import type { GetChangeRequestAuditByIdResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetChangeRequestAuditByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetChangeRequestAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetChangeRequestAuditByIdArgs = {
  id: string;
};

export const useGetChangeRequestAuditById = createQueryHook<
  UseGetChangeRequestAuditByIdArgs,
  GetChangeRequestAuditByIdResponseRow[],
  GetChangeRequestAuditByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.auditLog.getChangeRequestAuditById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({ change_request_audit: data }),
  graphqlDocument: GetChangeRequestAuditByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
